import { createSelector } from 'reselect'
import hasSubNavBarRouteUtil from 'modules/routes/utils/has-sub-nav-bar/index.js'
import getRouteAndMatchRouterSelect from 'modules/router/selectors/get-route-and-match/index.js'

const shouldHideSubNavbarRouterSelect = createSelector(
  getRouteAndMatchRouterSelect,
  (routeAndMatch) => {
    return !hasSubNavBarRouteUtil(routeAndMatch?.route?.path)
  }
)

export default shouldHideSubNavbarRouterSelect
